import ApplyNow from 'features/payOverTime/screens/application/ApplyNowLandingPage/ApplyNowLandingPage';
import React from 'react';

export default function Page() {
  return <ApplyNow />;
}
